__turbopack_context__.v({
  "ageModalWrapper": "AgeModal-module__1MaHcW__ageModalWrapper",
  "contentWrapper": "AgeModal-module__1MaHcW__contentWrapper",
  "controls": "AgeModal-module__1MaHcW__controls",
  "image": "AgeModal-module__1MaHcW__image",
  "text": "AgeModal-module__1MaHcW__text",
});
